import React from 'react'
import { BackButton, EditButton } from '../../../../../../Components/Utils/Buttons'
import { Link, useLocation, useParams } from 'react-router-dom'
import Dasboard from '../../../../../../Components/Icons/Dasboard'
import NuAmount from '../../../../../../Components/Utils/NuAmount'
import NuDate from '../../../../../../Components/Utils/NuDate'
import Breadcrumb from '../../../../../../Components/Utils/Breadcrumb'

function ViewReceived(id,receivedEditId,receivedViewId) {
  const location = useLocation();
  const data = location.state?.data;

  const { projEctId,officeId } = useParams();
            // const {officeId , estmationId} = useParams();
          const Paydata = location.state?.data;
          const pageIndex = location.state?.pageIndex;
          const searchQuery = location.state?.searchQuery;
  return (
    <div className="w-full h-[calc(100vh-120px)]  px-4 py-2 overflow-hidden ">
    <div className="md:flex justify-end w-full">
    {/* <Breadcrumb 
      items={[

        { name: "Petty Cash" },
           
        {
          name: "Received",
          link: `/project/petty-cash/received/${officeId}/${projEctId}`
        },

        { name: "View" },
      ]} 
            /> */}
      {/* <div className=" flex justify-between items-center float-right">
        <BackButton />
      </div> */}

       <div className=" flex gap-2">
                                  <Link to={`/project/petty-cash/received/${officeId}/${projEctId}`} state={{currentPage:pageIndex,searchQuery:searchQuery!=""?searchQuery:""}}><BackButton link={true}/></Link>
                                  <Link to={`/project/petty-cash/received/${officeId}/${projEctId}/edit/${receivedViewId}`} state={{data: data, from:`/project/petty-cash/received/${officeId}/${projEctId}/view/${receivedViewId}`}}><EditButton height='8'/></Link>
                                </div>
    </div>
    <div className=" w-full  h-[calc(100vh-127px)] bg-white overflow-y-auto mt-3 rounded-md  p-4 ">
      <div className=" w-full h-auto grid grid-cols-1  md:grid-cols-3">
        <div className=' my-2'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Project </p>
          <p className=' text-xs  text-mainColor-400'>{data?.projectName||"-"}</p>
        </div>
        <div className=' my-2'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Requested By</p>
          <p className=' text-xs  text-mainColor-400'>{data?.category||"-"}</p>
        </div>
        <div className=' my-2'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Date </p>
          <p className=' text-xs  text-mainColor-400'>{data?.date && data?.date !="" && data?.date !="None" && <NuDate value={data?.date} format="DD-MMM-YYYY" /> ||"0.0"}</p>
        </div>
        <div className=' my-2'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Requested Amount</p>
          <p className=' text-xs  text-mainColor-400'>
          <NuAmount value={data?.requestedAmount||0}/>
          </p>
        </div>
        <div className=' my-2'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Approved Amount</p>
          <p className=' text-xs  text-mainColor-400'>
          <NuAmount value={data?.approvedAmount||0}/>
          </p>
        </div>
        <div className=' my-2'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Balance Amount </p>
          <p className=' text-xs  text-mainColor-400'>
           <NuAmount value={data?.balanceAmount||0}/>
           </p>
        </div>

        <div className=' my-2'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Purpose </p>
          <p className=' text-xs  text-mainColor-400'>{data?.purpose||"-"}</p>
        </div>

        <div className=' my-2 col-span-3'>
          <p className=' text-[13px] font-medium text-mainColor-400'>Comments </p>
          <p className=' text-xs  text-mainColor-400'>{data?.comments||"-"}</p>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ViewReceived;